import * as $ from 'jquery';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
import 'bootstrap';

export class memberFlightRedemption {
	private scope:any = $('#members-redeem-flight');
	trackClickEvent () {
		$('#members-redeem-flights-btn').click(function () {
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Redemption Page - Flight',
                'clickName': 'click:btn-click:redeem-your-flights-now',
                'componentType': 'btn',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
			
		})
	}
}

let scope:Element = document.querySelector('#members-redeem-flight');

if (scope) {
	try {	
		let memberflightredemption = new memberFlightRedemption();
		var adobeDataLayer = new adobeDataLayerWrapper();
		adobeDataLayer.push('pageLoaded', {
			'pageName': '',
			'pageType': 'Enrich Redemption Page - Flight',
			'attributes': []
		});
		
		memberflightredemption.trackClickEvent();
	} catch(e) {console.error(e);}
}
